module.exports = __webpack_public_path__ + "media/interact.0e834331.mp4";